class GraphicList {
	constructor(container) {
		this._container = ge(container);
		this._graphics = [];
		this._active = null;

		this.selection = new SelectionMgr();
		this.tags = new TagList(TagList.GRAPHICS, this);
		this.sharing = new Sharing(Sharing.GRAPHIC);
		this.access = new Access(Access.GRAPHIC);
		
		this.selection.addButton(
			this.selectionTagBtn = UI.priIconBtn('tags', 18, {
				'click': () => this.getTags(this.selection.ids, this.selectionTagBtn)
			})
		);
		this._selAccessBtn = UI.priIconBtn('share', 18, {
			'mousedown': ev => stopEv(ev),
			'click': ev => this.access.open(this.selection.ids, ev.currentTarget)
		});
		this.selection.addButton(this._selAccessBtn);
		this.selection.addButton(
			UI.priIconBtn('delete', 18, {'click': this.deleteSelection.bind(this)})
		)

		this.emptyState = null;

		this.orderBy = ge('order-by');
		this.searchText = ge('search-text');
		this.filters = new FilterList();
		this.filters.addGroup('Source', 'source', new Sources('graphics'));
		this.filters.addGroup('Tags', 'tag', this.tags);

		onEv(this.orderBy, 'change', this.getList.bind(this));
		onEv(this.searchText, 'keyup paste', this.getList.bind(this));


		ge('sticky-bar').appendChild(UI.div('flex-0', [
			nav.userCan(MemberPermission.ADD_GRAPHICS)
				? UI.priIconBtn('plus-square', 18, {'click': _ => gUpload.open()})
				: null,
			nav.userCan(MemberPermission.ADD_GRAPHICS)
				? UI.priIconBtn('layer-plus', 18, {'click': _ => this.newComp = GraphicEditor.newComp()})
				: null,
			nav.userCan(MemberPermission.ADMIN) && nav.isCircle
				? new ContentFilter(MemberPermission.FILTER_GRAPHICS, this.getList.bind(this)).button
				: null,
			UI.priIconBtn('tags', 18, {'click': this.openTags.bind(this)}),
			this.filters.button
		]));

		onEv(document, 'primaryDataInvalid filterSelected', this.getList.bind(this));
		this.getList();
	}

	getList() {
		API.fetch('graphics', {
			order: this.orderBy.value,
			search: encodeURI(this.searchText.value),
			source: this.filters.getGroup('source'),
			tag: this.filters.getGroup('tag')
		})
		.then(json => {
			this._container.innerHTML = '';
			let graphics = json.graphics || json;
			if (graphics.length == 0) {
				this._container.appendChild(this.emptyState = UI.div('no-content', [
				UI.htm('h2', null, _("We can help with this empty space!")),
					UI.img(null, '/images/space/ufo.png'),
					UI.p(null, [
						// btn('btn', img(null, '/images/space/video-btn.png'), {
						// 	'click': () => pageFlow.fromStart(2)
						// }),
						UI.btn('', UI.img(null, '/images/space/guide-btn.png'), {
							'click': () => pageFlow.fromStart(10)
						})
					])
				]));
			}
			graphics.forEach(data => {
				let graphic = Graphic.fromArray(data, this);
				this._container.appendChild(graphic.elem);
			});
			if (json.access_summary) {
				for (let s of json.access_summary) {
					this.access.setSummary(parseInt(s.id), parseInt(s.view_count), parseInt(s.edit_count), json.unit_count);
				}
			}
			if (json.sharing_summary) {
				for (let s of json.sharing_summary) {
					this.sharing.setCount(parseInt(s.id), parseInt(s.share_count));
				}
			}
			document.dispatchEvent(new Event('primaryDataLoaded'));
		});
	}

	openTags() {
		this.tags.openDialog();
	}
	
	getTags(ids, button)
	{
		this._selectionIds = Array.isArray(ids) ? ids : [ids];
		
		this.tags.reset();
		this.tags.popup(button);

		API.fetch(
			'graphics/tags',
			{
				graphics: this._selectionIds
			}
		)
		.then(reply => {
			if(showError(reply)) return;

			if(reply.graphics) {
				for (let g of reply.graphics) {
					if (this._selectionIds.indexOf(g.graphic_id) === -1) continue;
					this.tags.increment(g.tag_id, this._selectionIds.length);
				}
			}
		});
	}

	toggleTag(tag) {
		if (tag.isSet) {
			API.insert(
				'graphics/tags',
				{
					graphics: this._selectionIds,
					tag: tag.id
				}
			)
			.then(reply => {
				showError(reply);
			});
		}
		else {
			API.delete(
				'graphics/tags',
				{
					graphics: this._selectionIds,
					tag: tag.id
				}
			)
			.then(reply => {
				showError(reply);
			});
		}
	}

	shareSelection(btn) {
		this.sharing.mapSelection(this.selection.ids, btn);
	}

	deleteSelection() {
		Dialog.Confirm(
			_("Delete all selected graphics, this CANNOT be undone!"),
			_("DELETE"),
			() => {
				API.delete('graphics/batch', {
					ids: this.selection.ids
				})
				.then(_ => {
					this.selection.clear();
					document.dispatchEvent(new Event('primaryDataInvalid'));
				});
			}, null, WARNING_DELETE_GRAPHIC_MULTI
		);
	}
}